
import { PlatformData } from './platform-data';

export class SellerDetector {
  private static readonly PRIVATE_SELLER_INDICATORS = [
    'personal', 'individual', 'private', 'home', 'garage', 'estate', 'moving',
    'collection', 'closet', 'wardrobe', 'preloved', 'gently used'
  ];

  private static readonly BUSINESS_INDICATORS = [
    'store', 'shop', 'company', 'inc', 'corp', 'llc', 'ltd', 'business',
    'enterprise', 'retail', 'wholesale', 'official', 'authorized', 'dealer'
  ];

  static isPrivateSeller(merchantName: string, searchText: string, platform: string): boolean {
    const normalizedMerchant = merchantName.toLowerCase();
    const normalizedSearch = searchText.toLowerCase();
    
    // Major B2C retailers are never private sellers
    if (PlatformData.isB2CRetailer(merchantName)) {
      return false;
    }

    // Check for explicit business indicators first
    const hasBusinessIndicators = this.BUSINESS_INDICATORS.some(indicator => 
      normalizedMerchant.includes(indicator) || normalizedSearch.includes(indicator)
    );
    
    if (hasBusinessIndicators) {
      return false;
    }

    // Check for private seller indicators
    const hasPrivateIndicators = this.PRIVATE_SELLER_INDICATORS.some(indicator => 
      normalizedMerchant.includes(indicator) || normalizedSearch.includes(indicator)
    );
    
    if (hasPrivateIndicators) {
      return true;
    }

    // Platform-specific logic
    switch (platform) {
      case 'amazon':
        // Amazon FBA sellers might have business names but are often private
        return !normalizedMerchant.includes('amazon') && 
               !this.BUSINESS_INDICATORS.some(indicator => normalizedMerchant.includes(indicator));
      
      case 'ebay':
        // eBay stores are usually businesses, individual sellers are private
        return !normalizedMerchant.includes('store') && 
               !normalizedMerchant.includes('shop');
      
      case 'etsy':
        // Most Etsy sellers are individual creators (private)
        return true;
      
      case 'facebook_marketplace':
      case 'offerup':
      case 'craigslist':
      case 'mercari':
        // These are primarily C2C platforms
        return true;
      
      default:
        // Default to business if we can't determine
        return false;
    }
  }
}
